<template>
	<div class="company_profile_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{$t('index.companyProfile')}}</div>
		</div>
		<div class="profile_pages">
			<img
				v-for="n in pageCount"
				:key="n"
				:src="pageUrl(n)"
				:alt="$t('index.companyProfile') + ' ' + n"
				loading="lazy"
			/>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'companyProfile',
		data() {
			return {
				pageCount: 12,
			};
		},
		created() {
			this.$parent.footer('index', false);
		},
		methods: {
			pageUrl(n) {
				const num = String(n).padStart(2, '0');
				return `/h5/company-profile/page_${num}.png`;
			},
		},
	};
</script>

<style lang="less" scoped>
	.company_profile_wrap {
		min-height: 100vh;
		background: #000;
	}

	.profile_pages {
		img {
			width: 100%;
			display: block;
		}
	}
</style>
